import React from "react";

const ClockSvg = () => {
	return (
		<>
			<svg
				width="23"
				height="24"
				viewBox="0 0 23 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<g id="Clock">
					<path
						id="Vector"
						d="M11.5 20.625C16.2635 20.625 20.125 16.7635 20.125 12C20.125 7.23654 16.2635 3.375 11.5 3.375C6.73654 3.375 2.875 7.23654 2.875 12C2.875 16.7635 6.73654 20.625 11.5 20.625Z"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeMiterlimit="10"
					/>
					<path
						id="Vector_2"
						d="M11.5 6.96875V12H16.5312"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</g>
			</svg>
		</>
	);
};
export default ClockSvg;
